export default function Tooltip({ tooltip, containerWidth, classes }) {
  if (!tooltip.visible) return null;

  const TOOLTIP_WIDTH = 110;
  const PADDING = 8;

  let left = tooltip.x;
  let transform = "translateX(-50%)";

  if (tooltip.x < TOOLTIP_WIDTH / 2 + PADDING) {
    left = PADDING;
    transform = "translateX(0)";
  }

  if (tooltip.x > containerWidth - TOOLTIP_WIDTH / 2 - PADDING) {
    left = containerWidth - PADDING;
    transform = "translateX(-100%)";
  }

  return (
    <div
      className={classes.tooltip}
      style={{ left, transform }}
    >
      {tooltip.text}
    </div>
  );
}